<template>
    <v-alert
        density="compact"
        theme="dark"
        color="grey-darken-2"
        class="add-service-snackbar cursor-pointer mb-0 rounded-0 w-100"
    >
        <template v-slot:prepend>
            <v-icon>mdi-account-search</v-icon>
            <span class="ms-2" v-text="snackbarText" />
        </template>
        <template v-slot:close>
            <v-dialog v-model="dialog" width="500">
                <template v-slot:activator="{props}">
                    <v-btn color="white" icon="mdi-close" variant="text" class="close-btn" v-bind="props" />
                </template>
                <v-card>
                    <v-card-title>
                        {{ `${$t('close')} ${$t('choose.agent_dialog_header').toLowerCase()}?` }}
                    </v-card-title>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn variant="flat" color="primary" @click="close"> ok </v-btn>
                        <v-btn variant="flat" @click="dialog = false">
                            {{ $t('cancel') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>
    </v-alert>
</template>

<script lang="ts">
    import {Component, Setup, Vue, Watch} from 'vue-facing-decorator'
    import hotels from '@/routes/hotels'
    import transfers from '@/routes/transfers'
    import activities from '@/routes/activities'
    import flights from '@/routes/flights'
    import packages from '@/routes/packages'
    import tours from '@/routes/tours'
    import extraServices from '@/routes/extraServices'
    import carsRent from '@/routes/carsRent'
    import cruises from '@/routes/cruises'
    import insurance from '@/routes/insurance'

    @Component
    export class AgentSearchSnackbar extends Vue {
        @Setup(() => useLocalized()) localized: Function

        dialog = false

        @Watch('$route', {immediate: true})
        onRouteChange(to) {
            if (!this.allowedRouteNames.includes(to.name)) {
                this.close()
            }
        }

        get selectedCompanyAndAgent() {
            return persistentStore.selectedCompanyAndAgent
        }

        get snackbarText() {
            if (!this.selectedCompanyAndAgent) {
                return null
            }
            return `${this.$t('search')} ${this.$t('and')} ${this.$t('booking')} ${this.$t('to_room')} ${this.localized(
                this.selectedCompanyAndAgent.company?.name
            )}${
                this.selectedCompanyAndAgent.agent?.firstName || this.selectedCompanyAndAgent.agent?.lastName ? ',' : ''
            } ${this.selectedCompanyAndAgent.agent?.firstName || ''}  ${
                this.selectedCompanyAndAgent.agent?.lastName || ''
            }`
        }

        close() {
            this.clear()
            this.dialog = false
        }

        clear() {
            persistentStore.SET_SELECTED_COMPANY_AND_AGENT(null)
        }

        get allowedRouteNames() {
            const allowedRouteNames = ['home', 'company-client-profile', 'companyClient']
            const productBookingFlowRouteNames = [
                ...hotels,
                ...transfers,
                ...activities,
                ...flights,
                ...packages,
                ...tours,
                ...extraServices,
                ...carsRent,
                ...cruises,
                ...insurance,
            ].map(el => el.name)
            return [...allowedRouteNames, ...productBookingFlowRouteNames]
        }
    }

    export default AgentSearchSnackbar
</script>
